import Vue from 'vue'

import Typeahead from "./Typeahead"

Vue.config.productionTip = false

const typeahead= document.getElementById('typeahead-app')

if (typeahead) {
    new Vue({
        el: '#typeahead-app',
        components: {
            Typeahead,
        }
    })
}
